var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"mt-10 pt-15 px-0 float-left"},[_c('extra-buttons')],1),_c("Agency",{tag:"component",attrs:{"de-active":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }